import { SVGProps, Ref, forwardRef } from 'react'
const SvgMultipleActionStar = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 20 21"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      clipPath="url(#MultipleActionStar_svg__a)"
    >
      <path d="M2.5 3.815a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0ZM8.953 10.061a4.376 4.376 0 0 0-8.328 1.88v1.874H2.5l.625 6.25h3.75l.435-4.346M14.956 10.424l1.285 2.767h2.5a.611.611 0 0 1 .432 1.069l-2.167 2.135 1.203 2.761a.655.655 0 0 1-.933.819l-2.909-1.632-2.906 1.634a.656.656 0 0 1-.932-.818l1.202-2.762-2.166-2.135a.612.612 0 0 1 .426-1.072h2.5l1.287-2.769a.666.666 0 0 1 1.178.003ZM11.563 3.503a2.188 2.188 0 1 0 4.375 0 2.188 2.188 0 0 0-4.376 0Z" />
      <path d="M17 8.19a3.75 3.75 0 0 0-6.07-.591" />
    </g>
    <defs>
      <clipPath id="MultipleActionStar_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" transform="translate(0 .69)" />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgMultipleActionStar)
export default ForwardRef
